import log from 'loglevel';
import React from 'react';
import { usePlayerContext } from '../../Context';
import ControlButton from '../../ui/ControlButton';

const Play = () => {
  const { sdk } = usePlayerContext();

  function play() {
    sdk.play();
  }
  const prefix = sdk.getClassNamePrefix();
  const bigButton = sdk.options().getControls().getBigButton();
  return (
    <div
      className={`${prefix}-player-control-big-button ${prefix}-player-control-big-button-${bigButton?.position} ${prefix}-player-control-big-button-play`}
      onPointerUp={(event) => {
        event.preventDefault();
        event.stopPropagation();
        play();
      }}
      role="button"
      //tabIndex={0}
      onKeyDown={() => {}}
    >
      <ControlButton
        className={'play'}
        icon={'play'}
        handleAction={() => {}}
        title={'Play'}
      />
    </div>
  );
};

export default Play;
